module.exports = __webpack_public_path__ + "static/media/wolframalpha.33a2e599.svg";